import { DateTime } from "luxon";

export const toDateInteger = (timestamp: DateTime) => {
  return parseInt(timestamp.toISO().substring(0, 10).replaceAll("-", ""), 10);
}